import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

import { provideAppStore } from './state/app-store.providers';

import { AUTH_API } from './state/apis/auth.api';
import { FirebaseAuthApi } from './state/apis/auth.firebase-api';

import { PROFILE_API } from './state/apis/profile.api';
import { FirebaseProfileApi } from './state/apis/profile.firebase-api';

import { AuthSessionSyncService } from './state/auth/auth-session-sync.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),

    provideRouter(routes),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),

    provideAppStore(),

    { provide: AUTH_API, useClass: FirebaseAuthApi },
    { provide: PROFILE_API, useClass: FirebaseProfileApi },

    provideAppInitializer(() => {
      inject(AuthSessionSyncService).init();
    }),
  ],
};
